import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { ArrowLeft } from "lucide-react";

// Fix AA (2026-09-17): se saca "Adelanto de sueldo" a pedido del cliente.
// Los adelantos se gestionan fuera de esta plataforma (app Naaloo). Las
// solicitudes de tipo "adelanto" YA CARGADAS se siguen mostrando con su
// etiqueta; lo que se quita es la posibilidad de crear nuevas.
const TYPES = [
  { v: "material", l: "Pedido de material" },
  { v: "refuerzo_compra", l: "Refuerzo / compras" },
  { v: "cambio_personal", l: "Cambio de personal" },
  { v: "otro", l: "Otro" },
];

export default function AdminNewRequest() {
  const nav = useNavigate();
  const [form, setForm] = useState({ type: "material", description: "", amount: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { type: form.type, description: form.description, amount: form.amount ? parseFloat(form.amount) : null };
      await api.post("/internal-requests", payload);
      toast.success("Solicitud registrada");
      nav("/admin/solicitudes");
    } catch (e2) { toast.error(formatApiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ padding: "20px 24px 60px" }}>
      <Link to="/admin/solicitudes" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--invict-text-muted)", fontSize: 12, marginBottom: 12, textDecoration: "none", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }} data-testid="req-new-back"><ArrowLeft size={14}/> Volver a Solicitudes</Link>
      <h1 style={{ fontSize: 32, fontWeight: 900, margin: "4px 0 18px", color: "#0A0A0A", letterSpacing: "-0.02em" }}>Nueva solicitud</h1>
      <form className="card" style={{ padding: 18, maxWidth: 560 }} onSubmit={submit} data-testid="admin-req-form">
        <div className="field"><label>Tipo</label>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="admin-req-type">
            {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
        {["adelanto", "refuerzo_compra"].includes(form.type) && (
          <div className="field"><label>Monto estimado (ARS)</label>
            <input type="number" min="0" step="100" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} placeholder="ej. 50000" data-testid="admin-req-amount"/>
          </div>
        )}
        <div className="field"><label>Descripción *</label>
          <textarea required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Detallá qué necesitás..." data-testid="admin-req-desc"/>
        </div>
        <button type="submit" className="btn-primary" disabled={busy} style={{ width: "100%", padding: 12 }} data-testid="admin-req-submit">{busy ? "Enviando..." : "Enviar solicitud"}</button>
      </form>
    </div>
  );
}
